import React, { useEffect, useRef, useCallback } from 'react';


const InfiniteScroll = ({ children, onLoadMore, hasMore, loading, className = '' }) => {
  const observerRef = useRef(null)

  const sentinelRef = useCallback((node) => {
    if(loading) {
      return
    }
    
    if(observerRef.current) {
      observerRef.current.disconnect() // Clean up previous observer
    } 

    observerRef.current = new IntersectionObserver((entries) => {
      // console.warn('load more', hasMore)
      // If the sentinel is visible and there is more data to fetch, load more
      if(entries[0].isIntersecting && hasMore) {
        // console.warn('load more')
        onLoadMore()
      }
    })

    if(node) {
      observerRef.current.observe(node)
    }
  }, [loading, hasMore, onLoadMore])

  // Clean up observer on unmount
  useEffect(() => {
    return () => {
      if(observerRef.current) {
        observerRef.current.disconnect()
      } 
    }
  }, [])


  return (
    <div className={className}>
      {children}

      <div ref={sentinelRef} style={{ height: '20px', background: 'transparent' }}>
        {loading && <p style={{ textAlign: 'center' }}>Loading...</p>}
      </div>
    </div>
  );
};

export default InfiniteScroll